module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Pfeffingen_BL-0dd2b43ca8625ed3532e4d74e48d6269.svg";